<template>
	<div class="container">
		<div class="d-none d-md-block">
			<div class="card">
				<div class="card-header">
					<h4 class="card-header-title">
						Payments
					</h4>
					<div class="float-right"></div>
				</div>
				<div class="table-responsive mb-0">
					<table class="table table-sm table-nowrap card-table">
						<thead>
							<tr>
								<th>Transaction ID</th>
								<th>Fees</th>
								<th>Amount</th>
								<th v-if="showsProcessingFee">
									Processing Fee
								</th>
								<th>Total</th>
								<th>Received At</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="payment in payments.data" :key="payment.id">
								<td>#{{ payment.transaction_id }}</td>
								<td>
									<div v-for="fee in payment.fees" :key="fee.id">
										{{ fee.title }} -
										<template v-if="fee.service">
											{{ moment(fee.service.date).format("DD/MM/YYYY") }} -
										</template>
										${{ fee.amount }}
									</div>
								</td>
								<td>${{ payment.amount }}</td>
								<td v-if="showsProcessingFee">
									<template v-if="!payment.is_client_service_payment">
										${{ payment.processing_fee }}
									</template>
								</td>
								<td>${{ payment.total }}</td>
								<td>{{ dateFormat(payment.created_at) }}</td>
								<td>
									<button
										type="button"
										class="btn btn-sm btn-outline-dark mb-2"
										:disabled="loading"
										@click="downloadReceipt(payment)">
										<i v-show="loading" class="fa fa-spinner"></i>
										Download Receipt
									</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="card-footer">
					<BPagination
						v-show="payments.meta.total > payments.meta.per_page"
						:model-value="payments.meta.current_page"
						:total-rows="payments.meta.total"
						:per-page="payments.meta.per_page"
						@update:model-value="fetchPayments"></BPagination>
				</div>
			</div>
		</div>
		<div class="d-block d-md-none">
			<div v-for="payment in payments.data" :key="payment.id"
				class="card">
				<div v-if="payment.transaction_id" class="card-header">
					<h4 class="card-header-title">
						#{{ payment.transaction_id }}
					</h4>
				</div>
				<div class="card-body">
					<ul class="list-group list-group-flush">
						<li class="list-group-item d-flex align-items-center justify-content-between px-0">
							<small>Amount</small> ${{ payment.amount }}
						</li>
						<li v-if="!payment.is_client_service_payment"
							class="list-group-item d-flex align-items-center justify-content-between px-0">
							<small>Processing Fee</small> ${{ payment.processing_fee }}
						</li>
						<li class="list-group-item d-flex align-items-center justify-content-between px-0">
							<small>Total</small> ${{ payment.total }}
						</li>
						<li class="list-group-item d-flex align-items-center justify-content-between px-0">
							<small>Created At</small> {{ dateFormat(payment.created_at) }}
						</li>
					</ul>
					<div v-if="payment.fees" class="clearfix mt-4">
						<h4>Fees</h4>
						<div class="table-responsive mb-0">
							<table class="table table-sm table-nowrap card-table">
								<tbody>
									<tr v-for="fee in payment.fees" :key="fee.id">
										<td>{{ fee.title }}</td>
										<td class="float-right">
											${{ fee.amount }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div class="row mt-2">
				<div class="col">
					<BPagination
						v-show="payments.meta.total > payments.meta.per_page"
						:model-value="payments.meta.current_page"
						:total-rows="payments.meta.total"
						:per-page="payments.meta.per_page"
						@update:model-value="fetchPayments"></BPagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { useDateFormat } from '@js/composables/useDateFormat';
	export default {
		props: [],
		setup() {
			const { dateFormat } = useDateFormat();
			return { dateFormat };
		},
		data() {
			return {
				payments: {
					data: [],
					meta: {},
				},
				loading: false,
			};
		},
		computed: {
			user() {
				return this.$store.getters['auth/user'];
			},
			showsProcessingFee() {
				return this.payments.data.some(payment => !payment.is_client_service_payment);
			},
		},
		mounted() {
			this.fetchPayments();
		},
		methods: {
			fetchPayments: function (page) {
				this.$axios
					.get('/api/payments', {
						params: {
							page: page ? page : null,
							user_id: this.user.id,
							method: 'online',
							per_page: 5,
						},
					})
					.then((response) => {
						this.payments = response.data;
					})
					.catch(() => {
						toastr.error('Error loading payments.');
					});
			},
			downloadReceipt(payment) {
				this.loading = true;

				this.$axios
					.get(`/api/payments/${payment.id}/receipt`, {
						responseType: 'blob',
					})
					.then((response) => {
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', `payment-${payment.reference}.pdf`);
						document.body.appendChild(link);
						link.click();

						toastr.success('Receipt downloaded');
					})
					.catch(() => {
						toastr.error('An error occurred while downloading the receipt');
					})
					.finally(() => {
						this.loading = false;
					});
			},
		},
	};
</script>

<style scoped>
p {
	margin-bottom: 0px;
}
</style>
